import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import qs from "qs";
import { useEffect } from "react";

import { useBookmark } from "~/components/content/content-bookmark/hooks";
import type { BookmarkQueryStringPayload } from "~/components/content/content-bookmark/types";
import { useLoginDialogStateHelper } from "~/components/login-dialog/hooks";
import { accountAtom } from "~/lib/account";
import { useRouterReplaceWithSanitizedKeys } from "~/lib/router/hooks";

import { SanitizedUrlKeys } from "./consts";

export const useContentBookmarkActionRedirect = () => {
  const { handleBookmarkAction } = useBookmark();
  const { asPath, pathname, query } = useRouter();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { user } = useAtomValue(accountAtom);

  const { openLoginDialog } = useLoginDialogStateHelper();

  // NOTE: Need to check isDataReady because this component occurs before the component
  //       containing SWR to fetch the data, reason for this component occurring before SWR is
  //       because we do not want to declare this component on a per page basis
  useEffect(() => {
    const parsedQueryString = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    }) as unknown as BookmarkQueryStringPayload;

    if (!parsedQueryString.action?.bookmark) {
      return;
    } else if (parsedQueryString.action?.bookmark && !user?.uuid) {
      openLoginDialog({
        destination: window.location.href,
        ga4CustomParameter: {
          trigger_point: "bookmark",
        },
      });
    } else if (parsedQueryString.action?.bookmark) {
      void handleBookmarkAction(
        {
          action: "bookmark",
          id: parsedQueryString.action.bookmark,
        },
        {},
        () => {
          void replace(
            SanitizedUrlKeys,
            { pathname, query },
            {
              shallow: true,
            },
          );
        },
      );
    }
  }, [asPath, handleBookmarkAction, pathname, query, replace, openLoginDialog, user?.uuid]);

  return null;
};
